import { useSyncExternalStore } from 'react';

/** Phone-sized viewports are ≤ 767px (Tailwind `max-md`). */
export const MOBILE_MAX_WIDTH_PX = 767;

export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH_PX}px)`;

function mediaQueryList(): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return null;
  }
  return window.matchMedia(MOBILE_MEDIA_QUERY);
}

function subscribe(onStoreChange: () => void): () => void {
  const query = mediaQueryList();
  if (query === null) {
    return () => {
      // matchMedia is unavailable; nothing to unsubscribe.
    };
  }
  query.addEventListener('change', onStoreChange);
  return () => {
    query.removeEventListener('change', onStoreChange);
  };
}

function getSnapshot(): boolean {
  return mediaQueryList()?.matches ?? false;
}

function getServerSnapshot(): boolean {
  return false;
}

/** True when the viewport is phone-sized (≤ 767px). False whenever matchMedia is unavailable. */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
